import { Sprite } from "pixi.js";
import raiseFlameJson from "./frames/flames/flames_low.json";
import loopFlameJson from "./frames/flames/flames_loop.json";
import loopTransitionJson from "./frames/flames/flames_transition.json";
import redFlameJson from "./frames/flames/flames_low_red.json";
import * as PIXI from "pixi.js";
import { createSprite } from "./helpers";
import * as TWEEN from "@tweenjs/tween.js";

export class ShuttleEnd {
  constructor() {}
  initShuttleEnd = () => {
    this.shuttleEnd = Sprite.from("spaceshipNewPNG");
    this.shuttleEnd.alpha = 1;
    this.shuttleEnd.name = "shuttle";
    this.shuttleEnd.y = -7;
    this.shuttleEnd.x = -1;
    this.shuttleEnd.scale.x = 0.78;
    this.shuttleEnd.scale.y = 0.78;
    this.shuttleEnd.anchor.set(0.5, 0.5);
    this.flame1 = new Flame(-118, 87); // marcxena
    this.flame2 = new Flame(118, 87, true); // marjvena
    this.flame1.name = "flame1";
    this.flame2.name = "flame2";
    this.container;
    this.tween == null;
  };
  setShuttleEndContainer = (container) => (this.container = container);

  initRedFlames() {
    this.redFlame_1 = new RedFlame(0, 55);
    this.redFlame_2 = new RedFlame(0, 70);
    this.redFlame_3 = new RedFlame(-51, 79);
    this.redFlame_4 = new RedFlame(50, 79);

    this.shuttleEnd.addChild(this.redFlame_1.redFlame);
    this.shuttleEnd.addChild(this.redFlame_2.redFlame);
    this.shuttleEnd.addChild(this.redFlame_3.redFlame);
    this.shuttleEnd.addChild(this.redFlame_4.redFlame);
  }

  addShuttle = () => {
    this.container.addChild(this.shuttleEnd);
    this.container.shuttle = this.shuttleEnd.name;
    this.shuttleEnd.addChild(this.flame1.raiseFlame);
    this.shuttleEnd.addChild(this.flame2.raiseFlame);

    this.flame1.startRaiseFlameAnimation();
    this.flame2.startRaiseFlameAnimation();
  };

  shuttleEngineStartAnimation = () => {
    this.shuttleEnd.addChild(this.flame1.loopFlame);
    this.shuttleEnd.addChild(this.flame1.loopTransitionFlame);
    this.shuttleEnd.addChild(this.flame2.loopFlame);
    this.shuttleEnd.addChild(this.flame2.loopTransitionFlame);
    if (this.tween) {
      this.tween.stop();
    }

    this.tween = new TWEEN.Tween(this.shuttleEnd)
      .to({ y: 4 }, 2000)
      .yoyo(true)
      .repeat(10000000)
      .easing(TWEEN.Easing.Linear.None)
      .start();

    let loopFlame1 = this.flame1.loopFlame;
    let loopFlame2 = this.flame2.loopFlame;

    loopFlame1.x = 4000;
    loopFlame2.x = 4000;
    loopFlame1.rotation = 0.4;
    loopFlame2.rotation = -0.4;
    this.flame1.startLoopAnimation();
    this.flame2.startLoopAnimation();
  };

  removeShuttleEnd = () => {
    if (this.shuttleEnd) {
      this.shuttleEnd.removeChild(this.flame1.raiseFlame);
      this.shuttleEnd.removeChild(this.flame1.loopFlame);
      this.shuttleEnd.removeChild(this.flame2.raiseFlame);
      this.shuttleEnd.removeChild(this.flame2.loopFlame);
      this.container.removeChild(this.shuttleEnd);
      if(this.tween){
        this.tween.stop()
      }
    }
  };

  fadeOutInBlackHole = () => {
    this.shuttleEnd.goUp = new TWEEN.Tween(this.shuttleEnd)
      .to({ y: -120 }, 1000)
      .easing(TWEEN.Easing.Sinusoidal.In)
      .start();
    this.shuttleEnd.fadeOut = new TWEEN.Tween(this.shuttleEnd)
      .to({ alpha: 0 }, 1000)
      .easing(TWEEN.Easing.Sinusoidal.In)
      .start();
    this.shuttleEnd.slowScale = new TWEEN.Tween(this.shuttleEnd.scale)
      .to({ x: 0.3, y: 0.3 }, 1000)
      .easing(TWEEN.Easing.Sinusoidal.In)
      .start();
  };
}

class RedFlame {
  constructor(x, y, r) {
    this.redFlame = createSprite(
      redFlameJson.frames,
      PIXI.Texture.from(
        PIXI.Loader.shared.resources["redFlamePNG"].texture.baseTexture
      )
    );
    this.redFlame.position.set(x, y);
    this.redFlame.gotoAndPlay(0);
    this.redFlame.loop = true;
    this.x = x;
  }
}

class Flame {
  constructor(x, y, r) {
    this.raiseFlame = createSprite(
      raiseFlameJson.frames,
      PIXI.Texture.from(
        PIXI.Loader.shared.resources["raiseFlamePng"].texture.baseTexture
      )
    );
    this.loopFlame = createSprite(
      loopFlameJson.frames,
      PIXI.Texture.from(
        PIXI.Loader.shared.resources["loopFlamePng"].texture.baseTexture
      )
    );

    this.loopTransitionFlame = createSprite(
      loopTransitionJson.frames,
      PIXI.Texture.from(
        PIXI.Loader.shared.resources["loopTransitionPng"].texture.baseTexture
      )
    );

    this.loopFlame.loop = true;
    this.loopTransitionFlame.loop = true;

    this.loopFlame.x = 4000;
    this.loopFlame.rotation = 0.4;
    this.loopFlame.y = y;
    // this.loopFlame.scale.set(1.2);

    this.raiseFlame.x = 4000;
    this.raiseFlame.rotation = r ? -0.4 : 0.4;
    this.raiseFlame.y = y;
    // this.raiseFlame.scale.set(1.2);
    this.x = x;

    this.loopTransitionFlame.x = 4000;
    this.loopTransitionFlame.rotation = r ? -0.4 : 0.4;
    this.loopTransitionFlame.y = y;
    // this.loopTransitionFlame.scale.set(1.2);
  }

  startRaiseFlameAnimation = () => {
    this.raiseFlame.gotoAndPlay(0);
    this.raiseFlame.x = this.x;
  };

  startRedFlameAnimation = () => {
    this.redFlame.gotoAndPlay(0);
    this.redFlame.x = this.x;
    this.redFlame.loop = true;
  };

  startLoopAnimation = () => {
    this.raiseFlame.stop();
    this.loopTransitionFlame.loop = false;
    this.loopTransitionFlame.gotoAndPlay(0);
    this.loopTransitionFlame.x = this.x;
    this.loopTransitionFlame.onComplete = () => {
      this.loopTransitionFlame.x = 4000;
      this.now = Date.now();
      this.loopFlame.gotoAndPlay(0);
      this.loopFlame.x = this.x;
    };
  };
}
